const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "onboarding-copy-2",
  transform: "translate(-591.000000, -237.000000)",
  stroke: "#F89E0A",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  transform: "translate(592.000000, 238.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M85.67,37 L85.67,79.58 C85.6590283,82.7068986 83.1268986,85.2390283 80,85.25 L6.25,85.25 C3.12082825,85.2444957 0.585504273,82.7091718 0.58,79.58 L0.58,37",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.42,82.61 L41,49.34 C42.255921,48.3208411 44.054079,48.3208411 45.31,49.34 L82.83,82.61",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.39,28.13 L85.67,37.03",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "32.85 9.07 43.12 0.16 53.4 9.07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.58,37.03 L10.85,28.14",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.58,37.03 L27.82,60.79",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.67,37.03 L58.42,60.79",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "75.4 45.47 75.4 8.97 10.85 8.97 10.85 45.47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.12,42.47 L56.12,30.47 C57.6327925,28.9067348 58.5066386,26.8344711 58.57,24.66 C58.57,20.3963617 55.1136383,16.94 50.85,16.94 C46.5863617,16.94 43.13,20.3963617 43.13,24.66",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.12,42.47 L30.12,30.47 C28.6002475,28.9104669 27.7221885,26.8366772 27.66,24.66 C27.66,20.3963617 31.1163617,16.94 35.38,16.94 C39.6436383,16.94 43.1,20.3963617 43.1,24.66",
  id: "Path"
}))));
function SvgIterableEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "87px",
    viewBox: "0 0 88 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Welcome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIterableEmail);
export default __webpack_public_path__ + "static/media/iterable-email.2f5beeda9003e3717add22c3dee9b449.svg";
export { ForwardRef as ReactComponent };